<template>
    <main>
        <HeaderTab :title="$t('compte.reinitialiser_mdp')" />
        <div id="content">
            <div class="container-fluid">
                <div class="box">
                   <form @submit.prevent="send">
                        <div class="form-group">
                            <label for="name">{{ $t('compte.password') }}<sup>*</sup></label>

                            <div class="input-group">
                                <input type="password" class="form-control" name="password" :placeholder="$t('compte.password')" v-model="form.password" :disabled="isWorking" autocomplete="off" required>
                            </div>
                        </div>

                        <div class="form-group">
                            <label for="name">{{ $t('compte.password_confirmation') }}<sup>*</sup></label>

                            <div class="input-group">
                                <input type="password" class="form-control" name="confirmPassword" :placeholder="$t('compte.password_confirmation')" v-model="form.confirmPassword" :disabled="isWorking" autocomplete="off" required>
                            </div>
                        </div>

                        <div>
                            {{ $t('compte.mdp_doit_contenir') }} :
                            <ul>
                                <li :class="password_lettre">{{ $t('compte.mdp_au_moins_une_lettre') }}</li>
                                <li :class="password_chiffre">{{ $t('compte.mdp_au_moins_un_chiffre') }}</li>
                                <li :class="password_symbole">{{ $t('compte.mdp_au_moins_symbole') }}</li>
                                <li :class="password_caracteres">{{ $t('compte.mdp_plus_6_caractere') }}</li>
                            </ul>
                        </div>

                        <b-alert v-if="errorInfos" variant="danger" show>
                            {{ errorInfos }}
                        </b-alert>

                        <button type="submit" :disabled="!canSubmit" v-on:click="checkForm" class="mt-4 btn btn-primary btn-block rounded-pill">
                            {{ $t('global.reinitialiser') }}
                            <font-awesome-icon v-if="isWorking" class="mr-1" :icon="['fas', 'spinner']" spin />
                        </button>
                    </form>
                </div>
            </div>
        </div>
    </main>
</template>

<script>

import User from '@/mixins/User'

export default {
    name: 'PasswordUpdate',
    mixins: [User],
    data: () => ({
        errorInfos: null,
        isWorking: false,
        form: {
            password: null,
            confirmPassword: null
        },
        canSubmit: false,
        password_lettre: 'password_red',
        password_chiffre: 'password_red',
        password_symbole: 'password_red',
        password_caracteres: 'password_red'
    }),
    methods: {
        async send() {
            this.errorInfos = null
            this.isWorking = true

            if (this.form.password !== this.form.confirmPassword) {
                this.errorInfos = this.getTrad('error.IPWC')
                this.isWorking = false
                return
            }

            try {
                await this.updatePassword(this.form.password)
            } catch (err) {
                this.errorInfos = err.message
            } finally {
                this.successToast('compte.toast.password_success')
                this.isWorking = false
            }
        },

        checkPassword(password) {
            this.canSubmit = true
            if (password.match(/[a-zA-Z]/)){
                this.password_lettre = 'password_green'
            } else {
                this.password_lettre = 'password_red'
                this.canSubmit = false
            }

            if (password.match(/\d/)){
                this.password_chiffre = 'password_green'
            } else{
                this.password_chiffre = 'password_red'
                this.canSubmit = false
            }

            if (password.match(/[!"#$%&'()*+,-.:;<=>?@[\]^_`{|}~]/)){
                this.password_symbole = 'password_green'
            } else{
                this.password_symbole = 'password_red'
                this.canSubmit = false
            }

            if (password.length >= 6){
                this.password_caracteres = 'password_green'
            } else{
                this.password_caracteres = 'password_red'
                this.canSubmit = false
            }
        }
    },
    watch: {
        'form.password' (val) {
            this.checkPassword(val)
        }
    },
    components: {
        HeaderTab: () => import('GroomyRoot/components/HeaderTab'),
    }
}
</script>